export default __webpack_public_path__ + "static/svelte-components-inside-angularjs-b5f41a5d33e75cae95d3de45e19f5202.png";